
export enum PagesEnum {
    WELCOME = "./welcome",
    HOME = "./",
    DASHBOARD = "./dashboard"

}
